var scrollLinksInit;

(function ($) {

	const selectors = {
		link: '[data-scroll-top]',
		scrollInidicator: '[data-scroll-indicator]'
	}

	scrollLinksInit = function () {
		$(selectors.link).on('click', (e) => {
			e.preventDefault();
			$('html, body').animate({ 'scrollTop': 0 }, 1000);
		});

		$('body').on('click', selectors.scrollInidicator, function (e) {
			e.preventDefault();

			var $next_section;
			if ($(this).attr('data-target')) {
				$next_section = $($(this).attr('data-target'));
			}
			if (!$next_section.length) {
				$next_section = $(this).closest('section').nextAll('section');
			}

			if ($next_section.length) {

				$next_section = $next_section.first();

				const header_height = $(window).width >= 900 ? 70 : 70;

				const win_height = $(window).height() - header_height;

				var offTop = $next_section.offset().top - header_height
				// if ($next_section.outerHeight() < win_height) {
				// offTop -= (win_height - $next_section.outerHeight()) / 2;
				// }

				$('html, body').stop().animate({ scrollTop: offTop });
			}
		});


		$('a[href^="#"]:not([href="#"])').on('click', function (e) {
			e.preventDefault();

			const target_id = $(this).attr('href').slice(1);
			const $target = $('#' + target_id + ', [data-id="' + target_id + '"]').filter(':visible');

			if ($target.length) {
				history.replaceState({}, '', this.href);
				$('html, body').stop().animate({ scrollTop: $target.offset().top - 70 }, 700);

			}

		})

	}

})(jQuery);


export default scrollLinksInit;